import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core";
import { notification } from "../utils/notifications";
import { cleanNotifications } from "../actions/index";
import { bindActionCreators } from "redux";

function NotificationCenter(props) {
  const { classes, t, notificationCenter } = props;

  useEffect(
    function () {
      if (notificationCenter.message !== null) {
        notification(t(`${notificationCenter.message}`), notificationCenter.type);

        setTimeout(function () {
          props.cleanNotifications();
        }, 3000);
      }
    },
    [notificationCenter]
  );

  return <span />;
}

function mapStateToProps(state) {
  return {
    notificationCenter: state.notificationCenter,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      cleanNotifications,
    },
    dispatch
  );
}

const styles = (theme) => ({});

export default withStyles(styles)(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(NotificationCenter)));
